<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col md="5">
          <side-effect-form :sideEffect="sideEffect" @emitData="update" />
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import SideEffectForm from '@/components/side-effect/SideEffectForm';
import BackBtn from '@/components/navigation/BackBtn.vue';
import SpinnerContainer from '@/components/container/SpinnerContainer.vue';

import { mapState } from "vuex";

export default {
  components: {
    SideEffectForm,
    BackBtn,
    SpinnerContainer,
  },
  computed: {
    ...mapState("SideEffect", ["sideEffect"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    update(data) {
      this.$store.dispatch("SideEffect/update", data).then(() => {
        this.$router.push('/side_effect')
      })
    },
  },
  created() {
    this.$store.dispatch("SideEffect/getEach", this.$route.params.id);
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
